import React from 'react'
import { useAuthenticationContext } from '../../Context/Authentication'
import TogglePage from './TogglePage'

const MainRecentOrder = () => {
  const { screenSize } = useAuthenticationContext()
  return (
    <div>
      <div className="p-2 bg-gray-100 flex flex-col justify-start"
        style={{
          maxWidth: `${screenSize.width}px`,
          minHeight: `${screenSize.height + 200}px`,
        }}>
        <div style={{ maxWidth: `${screenSize.width - 50}px` }}>
          <div className='row' style={{ width: `${screenSize.width - 50}px` }}>
            <TogglePage />
          </div>
        </div> 
      </div>
    </div>
  )
}


export default MainRecentOrder